"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = void 0;
const axios_1 = __importDefault(require("axios"));
const Interceptor_1 = __importDefault(require("./Interceptor"));
const camelize_1 = __importDefault(require("camelize"));
const change_case_1 = require("change-case");
function createClient(defaultSettings) {
    const httpClient = axios_1.default.create(Object.assign(Object.assign({ baseURL: defaultSettings.baseURL || window.location.origin }, defaultSettings.camelCaseDeserialization && {
        transformResponse(data) {
            return data ? (0, camelize_1.default)(JSON.parse(data)) : data;
        }
    }), defaultSettings.snakeCaseSerialization && {
        transformRequest(data) {
            if (data) {
                return JSON.parse((0, change_case_1.snakeCase)(data));
            }
            return data;
        }
    }));
    const httpAuthenticator = defaultSettings.httpAuthenticator || new Interceptor_1.default(defaultSettings);
    httpClient.interceptors.request.use(httpAuthenticator.onRequest);
    httpClient.interceptors.response.use(httpAuthenticator.onResponse, httpAuthenticator.onResponseError);
    return httpClient;
}
exports.createClient = createClient;
